const namespace = 'marketing/discounts/edit';
export default namespace;
